import { render, staticRenderFns } from "./PaymentFaliPage.vue?vue&type=template&id=8adcc7e2&"
import script from "./PaymentFaliPage.vue?vue&type=script&lang=js&"
export * from "./PaymentFaliPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports